/** @jsx jsx */

import {
  Children,
  Fragment as _,
  useState,
  memo,
  cloneElement,
  useContext,
} from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import PDF from 'components/lib/PDF';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import EditableBtn from 'components/lib/EditableBtn';
import SubmitBtn from './SubmitBtn';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext as InteractionContext } from './interactionContext';
import Media from 'components/lib/Media';
import Embed from 'components/lib/Embed';
import { Block } from 'factories/block';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import IELayout from 'components/Layouts/IELayout';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import Media_default from 'assets/Rectangle.png';
import TextEntryVariable from './TextEntryVariable';
import Feedback from 'components/lib/Feedback/Feedback_updated_022022';

const Components = {
  Row,
  Column,
  Text: ({ children, ...props }) => {
    return (
      <EditableText
        {...{
          ...props,
          placeholder:
            'Ask your users a question here, "i.e what is your name"',
        }}
      />
    );
  },
  InteractionColumn: ({ children }) => {
    return children?.[0] || null;
  },
  TextEntryVariable,
  Image: ({ children, ...props }) => {
    const updatedProps = {
      ...props,
    };

    if (!props.src) {
      updatedProps.placeholder = Media_default;
    }

    return <Image {...{ ...updatedProps, usePlaceholderValue: true }} />;
    //
  },
  ColumnImageAndText: ({ children }) => {
    const interactionContext = useContext(InteractionContext);
    const { props } = interactionContext;
    const { useMediaInColumn = false } = props;

    const [img, txt] = children;

    return (
      <div>
        {useMediaInColumn ? <div>{img}</div> : null}
        <div style={{ margin: '20px 0' }}>{txt}</div>
      </div>
    );
  },
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: SubmitBtn,
  Video,
  Audio,
  SVG,
  PDF,
  OpenPDF,
  Media,
  Embed,
  Transcript: ({ children }) => children,
  ...IELayout(InteractionContext),
};

const TextEntryVariableDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  const [showFeedback, setShowFeedback] = useState<boolean>(false);

  const renderedBlock = (interactionBlock.children as Block[]).map((child) => {
    return renderBlock(child, Components);
  });

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{
          ...interactionBlock,
          isOpen: props.isOpen,
          updateItemsSeen: null,
          showFeedback,
          setShowFeedback($: boolean) {
            setShowFeedback($);
          },
        }}
      >
        {renderedBlock}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default TextEntryVariableDisplay;
